/**
 * Converts a date selected in the user's timezone to its UTC calendar-date
 * representation. API date fields use this ISO `YYYY-MM-DD` form.
 */
export const toUtcDateString = (value: Date): string => {
  const utcDate = new Date(
    Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()),
  );

  return utcDate.toISOString().slice(0, 10);
};

/**
 * Parses a date-only API value as a local calendar date for date pickers.
 */
export const parseDateOnly = (value: string | Date): Date => {
  if (value instanceof Date) return value;

  const [year, month, day] = value.slice(0, 10).split("-").map(Number);

  return new Date(year, month - 1, day);
};

/**
 * The calendar date reached after counting `totalWorkingDays` working days
 * starting from and including `start` (skipping weekends and, via
 * `isFreeDay`, legal holidays) - mirrors the backend's
 * LeaveRequestUtils.calculateWorkingDays so an end date computed here yields
 * the same working-day count when re-checked server-side. Used to auto-fill
 * Child Birth's End date from its Start date.
 */
export const addWorkingDaysInclusive = (
  start: Date,
  totalWorkingDays: number,
  isFreeDay: (date: Date) => boolean = () => false,
): Date => {
  let current = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  let counted = 0;
  for (;;) {
    const day = current.getDay();
    if (day !== 0 && day !== 6 && !isFreeDay(current)) {
      counted++;
      if (counted >= totalWorkingDays) return current;
    }
    current = new Date(
      current.getFullYear(),
      current.getMonth(),
      current.getDate() + 1,
    );
  }
};
